<template>
    <client-page>

        <sub-visual
        sh="Contact"
        tabActive="오시는 길"
        bg="/images/sub/visual/sv1.png">
        </sub-visual>

        <section class="sub-section--first sub-section--last">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    오시는 길
                </h2>

                <iframe class="mb-12 mb-lg-24" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3171.3643506994827!2d127.21304991564394!3d37.35755484382564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b55ff1de75c53%3A0xf6c56394bc1ebfcf!2z6rK96riw64-EIOq0keyjvOyLnCDsmKTtj6zsnY0g7Jik7Y-s66GcIDY3My0xMA!5e0!3m2!1sko!2skr!4v1665121198813!5m2!1sko!2skr" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            
                <h3 class="tit mb-12 mb-lg-24 font-weight-semibold pl-10 pl-lg-38">
                    경기도 광주 본사
                </h3>

                <div class="w-100 border-top border-color-point border-lg-2 page-text">
                    <div class="d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom">
                        <p class="min-w-80px min-w-lg-100px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14">
                            주소
                        </p>
                        <p class="color-grey-51">
                            경기 광주시 오포읍 오포로 673-10
                        </p>
                    </div>
                    <div class="d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom">
                        <p class="min-w-80px min-w-lg-100px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14">
                            번호
                        </p>
                        <p class="color-grey-51">
                            031-765-2268
                        </p>
                    </div>
                    <div class="d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom">
                        <p class="min-w-80px min-w-lg-100px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14">
                            FAX
                        </p>
                        <p class="color-grey-51">
                            031-765-2389
                        </p>
                    </div>
                    <div class="d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom">
                        <p class="min-w-80px min-w-lg-100px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14">
                            E-MAIL
                        </p>
                        <p class="color-grey-51">
                            ist@ist-co.kr
                        </p>
                    </div>
                </div>
            
            </v-container>

        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
};
</script>

<style lang="scss" scoped>
</style>